export const buildImageUrl = (baseUrl, options = {}) => {
  // Builds a URL with query parameters from options.
  // Example:
  //   buildImageUrl('https://img.com/img.jpg', { w: 400, h: 300, fit: 'cover', auto: true })
  //   => 'https://img.com/img.jpg?w=400&h=300&fit=cover&auto'
  const queryOptions = {
    ...(options || {}),
  };
  const query = Object.entries(queryOptions)
    .filter(([, value]) => value !== undefined && value !== null && value !== false)
    .map(([key, value]) => {
      if (typeof value === 'boolean') {
        return encodeURIComponent(key);
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join('&');

  if (!query) {
    return baseUrl;
  }

  const fragmentIndex = baseUrl.indexOf('#');

  if (fragmentIndex !== -1) {
    const urlBeforeFragment = baseUrl.slice(0, fragmentIndex);
    const fragment = baseUrl.slice(fragmentIndex);
    const separator = urlBeforeFragment.includes('?') ? '&' : '?';

    return `${urlBeforeFragment}${separator}${query}${fragment}`;
  }

  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${query}`;
};

export default buildImageUrl;
